// extracted by mini-css-extract-plugin
export default {"iconText":"styles_iconText__bXr6u","icon":"styles_icon__EUDDy","detail":"styles_detail__w3zvG","text":"styles_text__9W6lb","info":"styles_info__KTkfW"};